import React, { useEffect, useState } from 'react';
import { bannerService, menuService, pageService } from '../../services/api';

function CMSManagement() {
  const [active, setActive] = useState('pages');
  const [pages, setPages] = useState([]);
  const [banners, setBanners] = useState([]);
  const [menus, setMenus] = useState([]);
  const [message, setMessage] = useState('');
  const [pageForm, setPageForm] = useState({ title: '', content: '', meta_title: '', meta_description: '', is_published: true });
  const [bannerForm, setBannerForm] = useState({ title: '', image: '', location: 'homepage', description: '', link: '', link_text: '', position: 0, is_active: true });
  const [menuForm, setMenuForm] = useState({ name: '', location: 'header', description: '', is_active: true });

  useEffect(() => {
    loadAll();
  }, []);

  const loadAll = async () => {
    const [pageData, bannerData, menuData] = await Promise.all([
      pageService.index(),
      bannerService.index(),
      menuService.index({ with_items: 1 }),
    ]);

    setPages(pageData.data || []);
    setBanners(Array.isArray(bannerData) ? bannerData : []);
    setMenus(Array.isArray(menuData) ? menuData : []);
  };

  const savePage = async (event) => {
    event.preventDefault();
    await pageService.store(pageForm);
    setPageForm({ title: '', content: '', meta_title: '', meta_description: '', is_published: true });
    setMessage('Page created.');
    loadAll();
  };

  const saveBanner = async (event) => {
    event.preventDefault();
    await bannerService.store(bannerForm);
    setBannerForm({ title: '', image: '', location: 'homepage', description: '', link: '', link_text: '', position: 0, is_active: true });
    setMessage('Banner created.');
    loadAll();
  };

  const saveMenu = async (event) => {
    event.preventDefault();
    await menuService.store(menuForm);
    setMenuForm({ name: '', location: 'header', description: '', is_active: true });
    setMessage('Menu created.');
    loadAll();
  };

  const deletePage = async (id) => {
    if (window.confirm('Delete this page?')) {
      await pageService.destroy(id);
      loadAll();
    }
  };

  const deleteBanner = async (id) => {
    if (window.confirm('Delete this banner?')) {
      await bannerService.destroy(id);
      loadAll();
    }
  };

  const deleteMenu = async (id) => {
    if (window.confirm('Delete this menu?')) {
      await menuService.destroy(id);
      loadAll();
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">CMS Management</h2>
        <div className="flex gap-2">
          {['pages', 'banners', 'menus'].map((tab) => (
            <button key={tab} onClick={() => setActive(tab)} className={`px-4 py-2 rounded capitalize ${active === tab ? 'bg-blue-600 text-white' : 'bg-white border'}`}>{tab}</button>
          ))}
        </div>
      </div>

      {message && <div className="mb-4 bg-green-50 border border-green-200 text-green-700 px-4 py-3 rounded">{message}</div>}

      {active === 'pages' && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <form onSubmit={savePage} className="bg-white rounded-lg shadow p-6 space-y-3">
            <h3 className="font-semibold text-lg">Create Page</h3>
            <input required placeholder="Title" value={pageForm.title} onChange={(e) => setPageForm({ ...pageForm, title: e.target.value })} className="w-full border rounded p-2" />
            <textarea placeholder="Content" rows="6" value={pageForm.content} onChange={(e) => setPageForm({ ...pageForm, content: e.target.value })} className="w-full border rounded p-2" />
            <input placeholder="Meta title" value={pageForm.meta_title} onChange={(e) => setPageForm({ ...pageForm, meta_title: e.target.value })} className="w-full border rounded p-2" />
            <textarea placeholder="Meta description" value={pageForm.meta_description} onChange={(e) => setPageForm({ ...pageForm, meta_description: e.target.value })} className="w-full border rounded p-2" />
            <button className="bg-blue-600 text-white px-4 py-2 rounded">Save Page</button>
          </form>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="font-semibold text-lg mb-4">Pages</h3>
            {pages.map((page) => (
              <div key={page.id} className="flex justify-between border-b py-3">
                <div>
                  <div className="font-medium">{page.title}</div>
                  <div className="text-sm text-gray-500">{page.slug}</div>
                </div>
                <button onClick={() => deletePage(page.id)} className="text-red-600">Delete</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {active === 'banners' && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <form onSubmit={saveBanner} className="bg-white rounded-lg shadow p-6 space-y-3">
            <h3 className="font-semibold text-lg">Create Banner</h3>
            <input required placeholder="Title" value={bannerForm.title} onChange={(e) => setBannerForm({ ...bannerForm, title: e.target.value })} className="w-full border rounded p-2" />
            <input required placeholder="Image URL" value={bannerForm.image} onChange={(e) => setBannerForm({ ...bannerForm, image: e.target.value })} className="w-full border rounded p-2" />
            <input required placeholder="Location" value={bannerForm.location} onChange={(e) => setBannerForm({ ...bannerForm, location: e.target.value })} className="w-full border rounded p-2" />
            <textarea placeholder="Description" value={bannerForm.description} onChange={(e) => setBannerForm({ ...bannerForm, description: e.target.value })} className="w-full border rounded p-2" />
            <input placeholder="Link" value={bannerForm.link} onChange={(e) => setBannerForm({ ...bannerForm, link: e.target.value })} className="w-full border rounded p-2" />
            <button className="bg-blue-600 text-white px-4 py-2 rounded">Save Banner</button>
          </form>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="font-semibold text-lg mb-4">Banners</h3>
            {banners.map((banner) => (
              <div key={banner.id} className="flex justify-between border-b py-3">
                <div>
                  <div className="font-medium">{banner.title}</div>
                  <div className="text-sm text-gray-500">{banner.location}</div>
                </div>
                <button onClick={() => deleteBanner(banner.id)} className="text-red-600">Delete</button>
              </div>
            ))}
          </div>
        </div>
      )}

      {active === 'menus' && (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <form onSubmit={saveMenu} className="bg-white rounded-lg shadow p-6 space-y-3">
            <h3 className="font-semibold text-lg">Create Menu</h3>
            <input required placeholder="Name" value={menuForm.name} onChange={(e) => setMenuForm({ ...menuForm, name: e.target.value })} className="w-full border rounded p-2" />
            <input required placeholder="Location" value={menuForm.location} onChange={(e) => setMenuForm({ ...menuForm, location: e.target.value })} className="w-full border rounded p-2" />
            <textarea placeholder="Description" value={menuForm.description} onChange={(e) => setMenuForm({ ...menuForm, description: e.target.value })} className="w-full border rounded p-2" />
            <button className="bg-blue-600 text-white px-4 py-2 rounded">Save Menu</button>
          </form>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="font-semibold text-lg mb-4">Menus</h3>
            {menus.map((menu) => (
              <div key={menu.id} className="flex justify-between border-b py-3">
                <div>
                  <div className="font-medium">{menu.name}</div>
                  <div className="text-sm text-gray-500">{menu.location}</div>
                </div>
                <button onClick={() => deleteMenu(menu.id)} className="text-red-600">Delete</button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CMSManagement;
